<template>
<div>
  <v-container>
    <v-btn v-if="!hideQueueButton" color="primary" :to="{ name : 'document-waiting' }">
      <v-icon>call_merge</v-icon>
    </v-btn>
    <div>
      <v-layout row wrap>
        <v-flex xs8 offset-xs2>
          <div class="file-container">
            <v-sheet color="green lighten-4" style='height:100px'>
              <span class="icon-add">Tutaj przeciągnij dokumenty luk kliknij by wybrać dokumenty</span>
            </v-sheet>
          </div>
        </v-flex>
        <v-flex xs12>
          <v-progress-linear indeterminate v-if="loadingAll"></v-progress-linear>
        </v-flex>
      </v-layout>
      <input type="file" style="display:none" id="fileInput" multiple="multiple" />
      <v-list v-if="files.length>0" two-line subheader>
        <v-subheader inset>Pliki
        </v-subheader>
        <v-divider inset></v-divider>

        <v-list-tile v-for="(item,key) in files" :key="item.title" avatar>
          <v-list-tile-avatar>
            <v-icon>{{ getIcon(item) }}</v-icon>
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-list-tile-title>{{ item.name }}</v-list-tile-title>
            <v-list-tile-sub-title>{{ Math.round(item.size/1024)  }}Kb</v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-dialog v-if="item.name.split('.').pop() == 'pdf'" max-width="650px">
              <v-btn icon ripple  slot="activator">
                <v-icon color="primary">preview</v-icon>
              </v-btn>
              <v-card>
                <PdfViewer  :file="item" />
              </v-card>
            </v-dialog>
          </v-list-tile-action>
          <v-list-tile-action>
            <v-btn :disabled="uploading.includes(item)"  @click="upload(key)" icon ripple>
              <v-icon color="green ">upload</v-icon>
            </v-btn>
          </v-list-tile-action>
          <v-list-tile-action>
            <v-btn :disabled="uploading.includes(item)"  @click="removeFile(item)" icon>
              <v-icon color="red lighten-1">delete</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
      <div v-if="files.length>0">
        <v-btn :disabled="loadingAll" color="green" @click="uploadAll()">
          Dodaj wszystkie
        </v-btn>
        <v-btn color="error" @click="removeAll()">
          Usun wszystkie
        </v-btn>
      </div>
    </div>
  </v-container>
</div>
</template>

<script>
import PdfViewer from '@/components/pdf/Viewer'
import i18n from '@/plugins/vuei18n'
import Messenger from "@/plugins/Messenger";
const ALLOWED_EXTENSIONS = ['pdf','jpg','jpeg','png','tiff']

export default {
  props:['hideQueueButton'],
  components: {
    PdfViewer
  },
  computed: {

  },
  data() {
    return {
      loading: true,
      loadingAll : false,
      files: [],
      fileInput: {},
      fileDivContainer: {},
      uploading : [],
    }
  },
  methods: {
    getIcon(file) {
      return file.name.split('.').pop() == "pdf" ? "picture_as_pdf" : "library_books"
    },
    isValid(file) {
      return ALLOWED_EXTENSIONS.includes(file.name.split('.').pop())
    },
     async uploadAll(){
       if(!(await this.askForUploadAll())){
         return
       }
      this.loadingAll = true
      let toRemove = []
      this.files.forEach(f => this.uploading.push(f))
      for(let index in this.files){
        let file = this.files[index]
        this.uploading.push(file)
        let formData = new FormData()
        formData.append('document', file)
        try {
          await this.$http.post('document', formData)
          toRemove.push(file)
        }catch (e) {
          Messenger.emitError("Bład przy dodawaniu pliku: " + file.name)
        }
      }
      toRemove.forEach((f) =>this.removeFile(f))
      this.loadingAll = false
      Messenger.emitSuccess("Dodano dokumenty")
    },
    askForUploadAll(){
      return this.$confirm("Czy na pewno chcesz dodać wsyztskie dokumenty?\n" +
          " Proszę nie odświeżąc strony do momentu załadowania wszystkich dokumentów")
    },
    upload(key) {
      let file = this.files[key]
      this.uploading.push(file)
      let formData = new FormData()
      formData.append('document', file)
      this.$http.post('document', formData).then(data =>{
        Messenger.emitSuccess("Dodano dokument")
        this.removeFile(file)
      }).catch(e =>{
        Messenger.emitError("Bład przy dodawaniu")
      })

    },
    removeAll() {
      this.fileInput.files = (new DataTransfer()).files
      this.files = []
    },
    removeFile(file) {
      let index = this.files.indexOf(file);
      if (index > -1) {
        this.files.splice(index, 1);
      }

      index = this.uploading.indexOf(file)
      if (index > -1) {
        this.uploading.splice(index, 1);
      }
    },
    getUniqueFiles(files){
      return [].filter.call(files,file =>
          !this.files.find(currentFille => file.name == currentFille.name))
    },
    onDropHandler(e) {
      e.preventDefault();
      let files = e.dataTransfer.files
      this.setFiles(files)
    },
    onFilePicked(e){
      let files = e.target.files
      this.setFiles(files)
    },
    setFiles(files){
      files = this.getUniqueFiles(files);

      [].forEach.call(files, (file) => {
        if (this.isValid(file)) {
          this.files.push(file)
        }
      });
    }
  },
  mounted() {
    this.fileDivContainer = document.querySelector('.file-container')
    this.fileInput = document.querySelector('#fileInput')

    this.fileDivContainer.ondragover =
      this.fileDivContainer.ondragenter = (e) => e.preventDefault();

    this.fileInput.onchange = this.onFilePicked
    this.fileDivContainer.ondrop = this.onDropHandler
    this.fileDivContainer.onclick = () => this.fileInput.click()
  }
}
</script>

<style scoped>
.file-container {
  border-style: dashed;
  color: gray;
  text-align: center;
  margin-bottom: 2rem;
  height:100px;
  box-sizing: content-box;
  cursor: pointer;
}

.icon-add {
  user-select: none;
  line-height: 100px;
  font-size: 24px;
  color: gray;
  opacity: 0.4
}
</style>
